// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__TLTgt","consentsList":"PatientConsents_consentsList__1yzYg","consentsListEmpty":"PatientConsents_consentsListEmpty__Y9rK_"};